<template>
  <div role="tablist">
    <template v-for="(group, index) in settingsVarsGroups">
      <b-button
        :key="`s-button-${index}`"
        block
        href="#"
        v-b-toggle="`s-settings-${index}`"
        variant="secondary"
        class="my-1"
      >
        {{ group }}
      </b-button>
      <b-collapse
        :key="`s-collapse-${index}`"
        :id="`s-settings-${index}`"
        accordion="settings"
        role="tabpanel"
        class="py-3"
      >
        <template
          v-for="(varItem, index) in getSettingsVarsForGroup(service.id, group)"
        >
          <hr
            v-if="index > 0"
            :key="`h-${varItem.id}`"
          />
          <setting-item
            :key="`s-${varItem.id}`"
            :setting-var="varItem"
          />
        </template>
      </b-collapse>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import config from '@/config';
import axios from 'axios';

export default {
  name: 'SettingsActor',
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getSettingsVarsForGroup',
      'getSettingsVarsGroups',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    settingsVarsGroups() {
      return this.getSettingsVarsGroups(this.service.id);
    },
  },
  methods: {
    ...mapActions([
      'updateVarsValues',
    ]),
    async updateSettingsData() {
      const url = this.$backendUrl(
        config.ICOOL.API.SERVICE_SETTINGS_DATA(this.currentSnapshot.id, this.service.id)
      );
      try {
        const response = await axios.get(url);
        this.updateVarsValues({ varItems: response.data.data });
      } catch (err) {
        this.$log.error(err);
      }
    },
  },
  mounted() {
    this.updateSettingsData();
  },
};
</script>

<style scoped>

</style>
